// import AppSeller from "@/views/seller/layout";
// import AppSeller from "@/AppSeller";

const routes = [
    // {
    //     path: "/seller",
    //     redirect: "/seller/index",
    //     // component: AppSeller,
    //     children: [
    //         // { path: "dashboard", name: "首页", component: () => import("../views/seller/dashboard") },
    //         // { path: "storeGoodsOrder", name: "产品订单", component: () => import("../views/seller/storeGoodsOrder") },
    //         // { path: "storeGoods", name: "产品仓库", component: () => import("../views/seller/storeGoods") },
    //         // { path: "userShopGoods", name: "产品", component: () => import("../views/seller/userShopGoods") },
    //         // { path: "storeGoodsOrderEvaluation", name: "产品评论", component: () => import("../views/seller/storeGoodsOrderEvaluation") },
    //         // { path: "userShop", name: "店铺设置", component: () => import("../views/seller/userShop") },
    //         // { path: "userLevel", name: "店铺等级", component: () => import("../views/seller/userLevel") },
    //         // { path: "userPid", name: "分销中心", component: () => import("../views/seller/userPid") },
    //         // { path: "userMoney", name: "财务中心", component: () => import("../views/seller/userMoney") },
    //         // { path: "userRecharge", name: "充值记录", component: () => import("../views/seller/userRecharge") },
    //         // { path: "userLeaveMessage", name: "工单", component: () => import("../views/seller/userLeaveMessage") },
    //         // { path: "user", name: "交易密码", component: () => import("../views/seller/user") },
    //
    //         // { path: "userMoney", name: "账变历史", component: () => import("../views/seller/dashboard") },
    //         // { path: "dashboard", name: "传播包", component: () => import("../views/seller/dashboard") },
    //     ]
    // }
];
export default routes;
